<div class="main-body col-12 col-sm-12">
  <div class="grid-container" id="shopping-list">
    @for (entry of items; track entry) {
      <div class="category-container col-12 col-sm-12"
        [ngStyle]="{'background-color': entry.category.backgroundColor}"
        >
        <h4>
          <fa-icon [icon]="entry.category.icon"></fa-icon>
          <span class="ml-5">{{entry.category.name}}</span>
        </h4>
        <div class="row" style="margin: auto;">
          @for (item of entry.items; track item) {
            <div class="shop-item"
              (click)="updateAmount(item)"
              [ngClass]="{ collected: isCollected(item), partial: isPartial(item)}"
            >{{item.name}}</div>
          }
        </div>
      </div>
    }
  </div>

  <div id="extra-item-container col-12 col-sm-12">
    <form (submit)="addExtraItem()" [formGroup]="itemGroup">
      <div class="form-group row">
        <label class="col-2 col-sm-2" for="extra-item">Meer</label>
        <div class="col-7 col-sm-7">
          <input id="extra-item" style="width: 100%;" type="text" formControlName="itemName" (keyup)="toggleEnableDisable()"/>
        </div>
        <div class="col-2 col-sm-2">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="itemGroup.invalid"
            >Add
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
